export default "__VITE_ASSET__f2241219__"